import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Ora Cacao's "Mystical Mushroom Cacao - Organic
// Ceremonial Chocolate" (p_1q1drdm1ah), pulled from Faire's live
// `GET /api/product-reviews/product/{product_token}` endpoint — verbatim
// comment, real reviewer, real rating, real publish date.
export const review_oc4: FaireReviewEntity = {
  token: "review_oc4",
  type: "review",
  brandName: "Ora Cacao",
  brandToken: "b_djuc44eyt2",
  productToken: "p_1q1drdm1ah",
  reviewType: "product",
  reviewerName: "Jody Frechette",
  reviewerLocation: "Madison, WI, United States",
  stars: 5,
  reviewText:
    "We have been using Ora Cacao personally in our life and more recently have expanded to sharing this with clients and customers. We are beyond thrilled to now have a way to purchase wholesale for our cacao ceremonies. Thank you!",
  reviewDate: "Nov 15, 2023",
  meta: {
    source: "api" as const,
    importedAt: "2026-08-11T20:50:10.000Z",
    importedBy: "entity-db-cli",
  },
};
